<template>
  <div>
    <h1>Create Topic <HelpIcon feature="topics.create" /></h1>
    <p>This is a placeholder page for creating a new topic.</p>
  </div>
</template>

<script>
import HelpIcon from '@/components/HelpIcon.vue'

export default {
  name: 'TopicCreate',
  components: { HelpIcon },
};
</script>
